<template>
  <v-container fluid>
    <v-row v-for="language in languages" :key="language.lang">
      <v-col md="6" offset-md="3">
        <v-btn block x-large rounded @click="goto(language.to)">
          <v-img class="rounded-circle float-left" max-width="46" max-height="46"
                 src="https://d1fdloi71mui9q.cloudfront.net/q5gXxUS3QNeJRVAIwsbu_%E8%B7%B3%E8%BD%AClogo%E6%9C%80%E6%96%B0_29.png"/>
          <v-flex>
            {{ language.text }}
          </v-flex>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LandingPage',
  computed: {
    languages() {
      return [
        {lang: 'US', to: '/warranty/us', text: this.$i18n.messages.US.landing.warranty},
        {lang: 'DE', to: '/warranty/de', text: this.$i18n.messages.DE.landing.warranty},
        {lang: 'JP', to: '/warranty/jp', text: this.$i18n.messages.JP.landing.warranty},
        {lang: 'FR', to: '/warranty/fr', text: this.$i18n.messages.FR.landing.warranty}
      ]
    }
  },
  data: () => ({

  }),
  methods: {
    goto(target) {
      this.$router.push(target)
    }
  }
}
</script>
